import { IDeck } from "@models/deck";
import { IKnol } from "@models/knol";
import { fieldNames } from "fields/layoutMarket/fieldNames";
import { MAGIC_LAYOUT_ID } from "fields/magicLayout";
import { superCache } from "hooks/data/superCache";
import L10n from "localization";
import { ID } from "types/ID";

export const tutorialCardID = "tutorial-card-id";

export function genTutorialDeck(): IDeck {
  return {
    id: "tutorial-deck-id",
    modified_at: new Date(),
    name: "Tutorial Deck",
    layout_id: MAGIC_LAYOUT_ID,
    config: {
      fields: [
        { type: "richtext", name: fieldNames.Front(), sides: [1, 1] },
        { type: "richtext", name: fieldNames.Back(), sides: [0, 1] },
      ],
    },
  };
}

export function genTutorialKnol(deckID: ID): IKnol {
  return {
    id: tutorialCardID,
    deck_id: deckID,
    created_at: new Date(),
    modified_at: new Date(),
    values: {
      [fieldNames.Front()]: L10n.localize((s) => s.onboarding.introCardFront),
      [fieldNames.Back()]: L10n.localize((s) => s.onboarding.introCardBack),
    },
  };
}

export function shouldShowIntroSlide(): boolean {
  // Check if this is a first-time user with zero responses
  return noResponses();
}

export function noResponses(): boolean {
  return superCache.responses?.size === 0;
}

export function exactlyOneResponse(): boolean {
  if (!superCache.responses) {
    return false;
  }
  let numResponses = 0;
  for (const [, layoutToResps] of superCache.responses) {
    for (const [, resps] of layoutToResps) {
      numResponses += resps.length;
    }
    if (numResponses > 1) {
      return false;
    }
  }
  return numResponses === 1;
}
